module.exports = __webpack_public_path__ + "img/web-p2-t2.512eaec4.svg";